import React from "react";
import useFetchInternal from "../hooks/useFetchInternal";
import LibraryPageLayout from "../components/LibraryPage/LibraryPageLayout";
import { BASE_URL } from "../constant/apiUrl";
import Loading from "../utils/Loader";
import { useSelector } from "react-redux";
import { setLibrary } from "../slices/LibraryPageSlice";
export default function Library() {
  const { library } = useSelector((store) => store.libraryDetailPage);
  const { loading } = useFetchInternal(
    `${BASE_URL}/library-page/find-all`,
    setLibrary,
    library,
    "Library"
  );

  const isLibraryEmpty =
    !library ||
    (Array.isArray(library) && library.length === 0) ||
    (typeof library === "object" && Object.keys(library).length === 0);

  if (loading || isLibraryEmpty) return <Loading data-testid="loading" />;
  return (
    <LibraryPageLayout
      pageData={library}
      header={"Library"}
      data-testid="library-page-layout"
    />
  );
}
